var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "private_area_tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": _vm.handleClick,
            "tab-remove": _vm.handleTabRemove,
          },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "私域领券", name: "private_area_table" } },
            [
              _c("private-area-table-pane", {
                ref: "private_area_table",
                on: {
                  toPrivateAreaConfig: _vm.handleToPrivateAreaConfig,
                  toPrivateAreaRecord: _vm.handleToPrivateAreaRecord,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showConfigTab
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.isEdit ? "编辑私域领券" : "添加私域领券",
                    name: "private_area_config",
                    closable: true,
                  },
                },
                [
                  _vm.showConfigTab
                    ? _c("private-area-config-pane", {
                        key: _vm.configKey,
                        attrs: {
                          id: _vm.currentId,
                          "send-type": _vm.currentSendType,
                        },
                        on: {
                          success: _vm.handleSuccess,
                          cancel: _vm.handleCancel,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.recordTabs, function (item) {
            return _c(
              "el-tab-pane",
              {
                key: item.name,
                attrs: { label: item.title, name: item.name, closable: true },
              },
              [
                _c("bonus-send-record-pane", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName === item.name,
                      expression: "activeName === item.name",
                    },
                  ],
                  ref: "bonus_send_record",
                  refInFor: true,
                  attrs: {
                    "bonus-send-id": item.bonusSendId,
                    "bonus-send-title": item.bonusSendTitle,
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }